<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="11" md="8">
        <v-card>
          <v-card-text class="text-body-2">
            {{message}}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>

export default {
  name: 'tUnsubscribe',
  components: {
  },
  props: [],
  data () {
    return {
      message: ''
    }
  },
  computed: {

  },
  mounted () {
    if (this.$route.params.email) {
      console.log('Unsubscribing ' + this.$route.params.email)
      this.$http.plain.get('/api/v1/public/customer_unsubscribe/' + this.$route.params.email + '?type=' + this.$route.query.type)
        .then(res => {
          this.message = 'You have been unsubscribed from our mailing list.'
        })
        .catch(err => {
          this.message = err
        })
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

  <style scoped>

  </style>
